import React from 'react';
import { Link } from 'react-router-dom';
import V3Header from '../components/V3Header';
import V3Footer from '../components/V3Footer';
import PdfScrollSection from '../components/PdfScrollSection';
import { useLanguage } from '../LanguageContext';
import {
  HyperlocalHeroVisual,
  EngagementHubVisual,
  TransparencyDashboardVisual,
} from '../components/visuals/DashboardVisuals';
import '../V3.css';

const bodyText = { fontSize: 14, color: '#222', lineHeight: 1.6 };

const V3HyperlocalPlatform = () => {
  const { t } = useLanguage();
  const features = t('hyperlocal.features');

  return (
    <div className="v3-app">
      <div className="v3-page">
        <V3Header
          activeNav="hyperlocal"
          primaryCta={<Link to="/request-a-demo" className="v3-btn primary">{t('common.watchDemo')}</Link>}
        />
        <div className="v3-hero">
          <div className="v3-tag-eyebrow">{t('common.vertical02')}</div>
          <h1>{t('hyperlocal.title')}</h1>
          <p style={bodyText}>{t('hyperlocal.intro')}</p>
          <HyperlocalHeroVisual />
        </div>

        <PdfScrollSection
          title="BRAHMOID TECH"
          src={`${process.env.PUBLIC_URL}/docs/brahmoid-tech.pdf`}
          height={780}
        />

        <section className="v3-block">
          <h2>{t('hyperlocal.featuresTitle')}</h2>
          <div className="v3-grid3">
            {Array.isArray(features) && features.map((f, i) => (
              <div key={f.title} className="v3-wire-block">
                <span className="v3-label">{t('common.feature')} {String(i + 1).padStart(2, '0')}</span>
                <strong style={{ color: '#111' }}>{f.title}</strong>
                <p style={{ ...bodyText, marginTop: 8 }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="v3-block">
          <h2>{t('hyperlocal.repBenefitsTitle')}</h2>
          <div className="v3-grid2">
            <div className="v3-wire-block">
              <strong style={{ color: '#111' }}>{t('hyperlocal.engagementHub')}</strong>
              <p style={{ ...bodyText, marginTop: 8 }}>{t('hyperlocal.engagementDesc')}</p>
              <EngagementHubVisual />
            </div>
            <div className="v3-wire-block">
              <strong style={{ color: '#111' }}>{t('hyperlocal.aiDashboard')}</strong>
              <p style={{ ...bodyText, marginTop: 8 }}>{t('hyperlocal.aiDashboardDesc')}</p>
              <TransparencyDashboardVisual />
            </div>
          </div>
        </section>

        <V3Footer />
      </div>
    </div>
  );
};

export default V3HyperlocalPlatform;
